import React, { useContext } from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { Url } from '@wix/da-url';
import { useIsMounted } from '@wix/da-hooks/pkg/useIsMounted';
import TextButton from '@wix/da-ds/pkg/Buttons/TextButton';
import { ThemeOptions, ThemeOverride, } from '@wix/da-react-context/pkg/ThemeContext';
import { SubscriptionPurchaseFTUEContext } from './SubscriptionPurchaseFTUEContext';
import s from './SubscriptionPurchaseFTUE.scss';
var ILLUSTRATION_URL = Url.staticCDNLink('eclipse/global/svg/congrats-ms-hexagon.svg');
/** Displays a ftue popup for viewers of in-tier deviations after
 *  their first time subscribing to a tier. */
export var SubscriptionPurchaseFTUE = function (_a) {
    var className = _a.className;
    var t = useTranslation().t;
    var isMounted = useIsMounted();
    var ftuePhase = useContext(SubscriptionPurchaseFTUEContext);
    var isShown = !!ftuePhase;
    if (!isShown) {
        return null;
    }
    return (React.createElement("div", { className: classnames(s['root'], isMounted && s['mounted'], ftuePhase !== 'overlay' && s['fading-out'], className) },
        React.createElement("img", { className: s['illustration'], src: ILLUSTRATION_URL, alt: "" }),
        React.createElement("section", { className: s['ftue-explanation'] },
            React.createElement("h6", { className: s['heading'] }, t('deviation.tier.ftue.subscriptionUnlocked.heading')),
            React.createElement("p", null, t('deviation.tier.ftue.subscriptionUnlocked.explanation')),
            React.createElement(ThemeOverride, { theme: ThemeOptions.DARK },
                React.createElement(TextButton, { className: s['got-it'], size: "small", variant: "approval-green" }, t('deviation.tier.ftue.subscriptionUnlocked.gotIt'))))));
};
SubscriptionPurchaseFTUE.displayName = 'SubscriptionPurchaseFTUE';
export default SubscriptionPurchaseFTUE;
//# sourceMappingURL=SubscriptionPurchaseFTUE.js.map